import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CUtilit } from 'src/app/classes/utilit';
import { ActivatedRoute } from '@angular/router';
import { DashBoard } from 'src/app/classes/json-interface';
import { ArmaServConnection } from 'src/app/classes/info-connection';
import { AppToolbarService } from 'src/app/components/toolbar/services/app-toolbar.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggedUserService } from 'src/app/services/loged-user/loged-user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  HTML_arrayDashbordIMG: any[];

  mDashboard?: DashBoard;

  constructor(private mHttp: HttpClient,
              private mSanitizer: DomSanitizer,
              private mRoute: ActivatedRoute,
              private mToolbar: AppToolbarService,
              private mLoggedUser: LoggedUserService) {
    this.HTML_arrayDashbordIMG = [];
    // Quand les params de la page changent on execute le code suivant
    this.mRoute.params.subscribe(params => this.initDashBoard(params.id));
  }
  ngOnInit() { }

  async initDashBoard(noDash: any) {
    this.HTML_arrayDashbordIMG = [];
    //let noDash = this.mRoute.snapshot.params.id;

    // Trouve le dashboard en fonction de l'IdDash
    for (const item of this.mLoggedUser.arrayDashBoard) {
      if (item.NoDash == noDash) {
        this.mDashboard = item;
        break;
      }
    }

    if (this.mDashboard) {
      this.mToolbar.toolbarPageTitle = this.mDashboard.Name;
      for (let i = 0; i < this.mDashboard.Count; i++) {
        this.HTML_arrayDashbordIMG.push(
          await ArmaServConnection.getSafeUrlImgFromDatasnap(
            this.mHttp,
            this.mSanitizer,
            'GetDashboardGraph',
            [this.mDashboard.NoDash, i]
          )
        );
      }
    } else {
      throw 'No dashBoard found';
    }
  }


  public get getNgClassStyleColor() {
    return CUtilit.getNgStyleBorderColor(
      this.mLoggedUser.isArmaorUserConnected,
      this.mLoggedUser.isCustomerConnected
    );
  }

  public get armaorColor(): any {
    if (this.mLoggedUser.isArmaorUserConnected) {
      return CUtilit.getArmaorUserColorCode();
    }
    return CUtilit.getUserSiteColorCode();
  }

}
